import instance from "./baseRequest";

export const aboutStatsApi = {
  getAllAboutStats: async () => await instance.get("/admin/about-stats"),
  getAboutStatsById: async (id) =>
    await instance.get(`/admin/about-stats/${id}`),
  createAboutStats: async (data) => {
    return await instance.post("/admin/about-stats", data);
  },
  updateAboutStats: async (id, data) => {
    return await instance.put(`/admin/about-stats/${id}`, data);
  },
  deleteAboutStats: async (id) =>
    await instance.delete(`/admin/about-stats/${id}`),
};
